import { createAction } from "redux-actions";

export const wsConnect = "WS_CONNECT";
export const wsConnectAction = createAction(wsConnect);

export const wsConnecting = "WS_CONNECTING";
export const wsConnectingAction = createAction(wsConnecting);

export const wsConnected = "WS_CONNECTED";
export const wsConnectedAction = createAction(wsConnected);

export const wsDisconnect = "WS_DISCONNECT";
export const wsDisconnectAction = createAction(wsDisconnect);

export const wsDisconnected = "WS_DISCONNECTED";
export const wsDisconnectedAction = createAction(wsDisconnected);

export const wsNewMessage = "WS_NEW_MESSAGE";
export const wsNewMessageAction = createAction(wsNewMessage);

// SetUnreadThreadCount
export const WS_SET_UNREAD_THREAD_COUNT = "WS_SET_UNREAD_THREAD_COUNT";
export const WSSetUnreadThreadCount = createAction(WS_SET_UNREAD_THREAD_COUNT);